/* eslint-disable */
import React, { useState, useEffect, Fragment } from 'react';
import { useForm, useFieldArray } from "react-hook-form";
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import Spinner from '../cutomComponent/spinner';
import useGlobalStore from '../store.js';
import { useAllWebhook } from '../api.js';
import 'react-toastify/dist/ReactToastify.css';

export default function WebhookSetup() {
  const { token, headers, host, noAuth } = useGlobalStore();
  const [isEdit, setEdit] = useState("");
  const { register, control, handleSubmit, reset, formState: { errors } } = useForm({});
  const { fields, append, remove } = useFieldArray({ control, name: "webhook" });

  const webhookQuery = useAllWebhook();

  if (!token) noAuth();
  if (webhookQuery.isLoading) return <Spinner />;
  if (webhookQuery.isError && webhookQuery.error?.response?.status === 401) noAuth();

  const onSave = (formDatas) => {
    axios
      .post(`${host}/webhookSave`, formDatas, headers)
      .then(response => {
        reset({
          webhook_name: '',
          webhook_type: '',
          webhook: []
        });
        webhookQuery.refetch();
        toast.success(response.data.message);
      })
      .catch(error => {
        console.error(error);
        toast.error('Failed to save webhook');
      });
  };

  const webhookList = () => {
    if (webhookQuery.data && webhookQuery.data.length > 0) {
      return webhookQuery.data.map(item => (
        <tr key={item.id}>
          <td>{item.webhook_name}</td>
          <td>{item.webhook_type}</td>
          <td>{item.webhook_url}</td>
          <td>
            <button type="button" className="btn btn-danger btn-sm">Del</button>
            <br />
            <button type="button" className="btn btn-info btn-sm" onClick={() => setEdit(item.id)}>Edit</button>
          </td>
        </tr>
      ));
    }
    return null;
  };

  const Updateform = ({ editId }) => {
    const webhookDetailQuery = useQuery({
      queryKey: ['webhook_with_id', editId],
      queryFn: async () => {
        const response = await axios.get(`${host}/webhookDetail/${editId}`, headers);
        return response.data?.data || {};
      },
      enabled: !!editId,
    });

    const {
      register: editReg,
      control: editControl,
      handleSubmit: editSubmit,
      formState: { errors: editErr },
      reset: editReset
    } = useForm({ defaultValues: { webhook_name: '', webhook_type: '', webhook: [] } });

    const { fields: editFields, append: editAppend, remove: editRemove } = useFieldArray({
      control: editControl,
      name: "webhook"
    });

    useEffect(() => {
      if (webhookDetailQuery.data?.webhookData) {
        editReset({
          webhook_name: webhookDetailQuery.data.webhookData.webhook_name || '',
          webhook_type: webhookDetailQuery.data.webhookData.webhook_type || '',
          webhook: webhookDetailQuery.data.webhook_feild || []
        });
      }
    }, [webhookDetailQuery.data, editReset]);

    const actionEdgeEdit = (formDatas) => {
      axios
        .post(`${host}/webhookUpdate/${editId}`, formDatas, headers)
        .then(response => {
          setEdit("");
          webhookQuery.refetch();
          toast.success(response.data.message);
        })
        .catch(error => {
          console.error(error);
          toast.error('Failed to update webhook');
        });
    };

    return (
      <div>
        {/* Modal container */}
        <div className="flex fixed inset-0 z-50 items-center justify-center">
          <div className="w-auto my-6 mx-auto">
            <div className="p-3 rounded-lg border border-gray-200 shadow-lg bg-white">
              {
              webhookDetailQuery.isLoading ? (<Spinner />) :
              webhookDetailQuery.isError ? (<div className="text-danger">Error loading webhook details</div>) :
              (
                <form onSubmit={editSubmit(actionEdgeEdit)}>
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <input {...editReg("webhook_name", { required: true })} placeholder="Enter Webhook Name" className="form-control"/>
                      {editErr.webhook_name && (<span className="text-danger">Webhook Name is required</span>)}
                    </div>
                    <div className="col-md-6">
                      <select {...editReg("webhook_type", { required: true })} className="form-select">
                        <option value="">Select Webhook Type</option>
                        <option value="get">GET</option>
                        <option value="post">POST</option>
                      </select>
                      {editErr.webhook_type && (<span className="text-danger">Webhook Type is required</span>)}
                    </div>
                  </div>

                  {editFields.map((item, index) => (
                    <div className="row mb-2" key={item.id}>
                      <div className="col-md-5">
                        <input {...editReg(`webhook.${index}.field_name`, { required: 'Field name is required' })} placeholder="Field Name" className="form-control"/>
                      </div>
                      <div className="col-md-5">
                        <select {...editReg(`webhook.${index}.field_type`, { required: 'Field type is required' })} className="form-select">
                          <option value="text">Text</option>
                          <option value="number">Number</option>
                        </select>
                      </div>
                      <div className="col-md-2 text-center">
                        <button type="button" onClick={() => editRemove(index)} className="btn btn-danger" ><i className="fa fa-trash"></i></button>
                      </div>
                    </div>
                  ))}

                  <div className="text-end mb-2">
                    <button type="button" onClick={() => editAppend({ field_name: '', field_type: 'text' })} className="btn btn-success">
                      <i className="fa fa-plus"></i> Add Field
                    </button>
                  </div>

                  <div className="d-flex justify-content-end">
                    <button type="button" onClick={() => setEdit("")} className="btn btn-outline-danger mx-2">Close</button>
                    <button type="submit" className="btn btn-primary">Update</button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
        <div className="opacity-50 fixed inset-0 z-40 bg-black"></div>
      </div>
    );
  };

  return (
    <Fragment>
      <ToastContainer />
      {isEdit && <Updateform editId={isEdit} />}
      <div className="container-fluid">
        <h1 className="mb-4 text-gray-800"><i className="fa-brands fa-slack"></i> Webhook Setting</h1>
        <div className="row">
          <div className="col-md-6">
            <form onSubmit={handleSubmit(onSave)}>
              <div className="card">
                <div className="card-header">Webhook Info</div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <input {...register("webhook_name", { required: true })} placeholder="Enter Webhook Name" className="form-control" />
                      {errors.webhook_name && <span className="text-danger">Required</span>}
                    </div>
                    <div className="col-md-6">
                      <select {...register("webhook_type", { required: true })} className="form-select">
                        <option value="">Select Type</option>
                        <option value="get">GET</option>
                        <option value="post">POST</option>
                      </select>
                      {errors.webhook_type && <span className="text-danger">Required</span>}
                    </div>
                  </div>

                  {fields.map((item, index) => (
                    <div className="row mb-2" key={item.id}>
                      <div className="col-md-5">
                        <input {...register(`webhook.${index}.field_name`, { required: true })} placeholder="Field Name" className="form-control"/>
                      </div>
                      <div className="col-md-5">
                        <select {...register(`webhook.${index}.field_type`, { required: true })} className="form-select">
                          <option value="text">Text</option>
                          <option value="number">Number</option>
                        </select>
                      </div>
                      <div className="col-md-2 text-center">
                        <button type="button" onClick={() => remove(index)} className="btn btn-danger"><i className="fa fa-trash"></i></button>
                      </div>
                    </div>
                  ))}
                  <div className="text-end">
                    <button type="button" onClick={() => append({ field_name: '', field_type: 'text' })} className="btn btn-success"><i className="fa fa-plus"></i> Add Field</button>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button type="submit" className="btn btn-primary">Save Webhook</button>
                </div>
              </div>
            </form>
          </div>

          <div className="col-md-6">
            <div className="card">
              <div className="card-header">Webhook List</div>
              <div className="card-body">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>URL</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {webhookList()}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
